import React from "react";
import { Alert } from "react-bootstrap";
import BypassAutoDispositionBadge from "components/BypassAutoDispositionBadge";

const VALUE_FALLBACK = "—";

/**
 * Non-red summary for transcription details when auto disposition was bypassed at UFL link.
 */
const BypassTranscriptionSummary = ({
  transcriptionIdLabel = "Transcription Id",
  transcriptionId,
  disposition,
  associatedSwitchId,
}) => {
  return (
    <div data-testid="bypass-transcription-summary">
      <Alert variant="info" className="mb-3">
        <div className="mb-2">
          <BypassAutoDispositionBadge showInlineMessage={false} />
        </div>
        <div className="mb-0 text-muted">
          This fax skipped auto disposition and was sent for manual review.
        </div>
      </Alert>

      <Alert variant="light" className="border mb-3">
        <strong>{transcriptionIdLabel}</strong>: {transcriptionId}
      </Alert>

      <Alert
        variant="light"
        className="border mb-3"
        data-testid="bypass-summary-associated-switch"
      >
        <strong>Associated Switch</strong>:{" "}
        {associatedSwitchId || VALUE_FALLBACK}
      </Alert>

      <Alert
        variant="light"
        className="border mb-3"
        data-testid="bypass-summary-disposition"
      >
        <strong>Disposition</strong>: {disposition || VALUE_FALLBACK}
      </Alert>
    </div>
  );
};

export default BypassTranscriptionSummary;
